/**
 * 主にAndroid版LINEミニアプリ向けの不具合回避用機能
 * 明示的にユーザーのクリックでマイクや音声を初期化するのに使用する
 * @param onInteractCallback
 *
 */
export const initFirstInteractWall = (onInteractCallback: () => void) => {
  // オーバーレイ div を作成
  const overlay = document.createElement('div');
  overlay.id = 'interactOverlay';
  Object.assign(overlay.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '9999',
    cursor: 'pointer'
  });

  // 中央の文字
  const text = document.createElement('div');
  text.innerText = 'CLICK TO PLAY';
  Object.assign(text.style, {
    color: 'white',
    fontSize: '2rem',
    fontFamily: 'Arial, sans-serif',
    userSelect: 'none'
  });

  overlay.appendChild(text);
  document.body.appendChild(overlay);

  // クリックイベント
  overlay.addEventListener('click', () => {
    overlay.remove(); // オーバーレイを削除
    onInteractCallback();
  });
};
